import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Alert } from "reactstrap";
import DeviceLastSeen, { getDeviceLastSeen } from "./DeviceLastSeen";

// Define the expected props
interface DeviceStatusProps {
    only_errors?: boolean;
    link_settings?: boolean;
}

export default function DeviceStatus({ only_errors = false, link_settings = false }: DeviceStatusProps) {
    const selected_mini = useSelector((state: any) => state.devices.selected_mini);
    const [deviceState, offline] = getDeviceLastSeen(selected_mini, true);

    if (!selected_mini) {
        return (
            <div>
                <Alert color="warning">
                    No device selected
                    {link_settings && (
                        <p className="mb-0">
                            <Link to="/settings">Select a device in your settings.</Link>
                        </p>
                    )}
                </Alert>
            </div>
        );
    }

    if (offline) {
        return (
            <Alert color="warning">
                {deviceState?.name} is probably not connected.{" "}
                <DeviceLastSeen device={deviceState} refresh={true} />
            </Alert>
        );
    }

    if (only_errors) {
        return null;
    }

    return (
        <div>
            <Alert color="success">
                {deviceState?.name} is online.{" "}
                <DeviceLastSeen device={deviceState} refresh={true} />
            </Alert>
        </div>
    );
}
